import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Flex } from "@chakra-ui/react";
import { useNav } from "~/OnboardingApp/features/Nav";

export const ContinueCta: FC = () => {
  const { t } = useTranslation();
  const { goToNext } = useNav();

  const handleContinue = () => {
    goToNext();
  };

  return (
    <Flex justify="center" w="full">
      <Box maxW="16.5rem" position="relative" w="full">
        <Button
          onClick={handleContinue}
          size="th-md"
          variant="th-primary"
          w="full"
        >
          {t("onboarding.someLogisticsPage.continueCta")}
        </Button>
      </Box>
    </Flex>
  );
};
